import React, { FC, useMemo } from 'react';
import { startOfToday } from 'date-fns';
import { Text } from '@moda/om';
import { FulfillmentTypes } from '@moda/portal-stanchions';
import { PdpInfoContainerFragment } from '../../../generated/types';
import { formatDeliveryDate } from '../formatDeliveryDate';

import './PdpDeliveryInfo.scss';

type DeliveryDates = NonNullable<PdpInfoContainerFragment['masterVariant']['processDeliveryDates']>;

interface Props {
  deliveryDates?: DeliveryDates | null;
  fulfilmentType?: number | null;
  customerDeliveryNotes?: string | null;
}

export const PdpDeliveryInfo: FC<Props> = ({
  deliveryDates,
  fulfilmentType,
  customerDeliveryNotes
}) => {
  const shippingStart = useMemo(
    () => (deliveryDates?.deliveryStartsOn ? new Date(deliveryDates.deliveryStartsOn) : undefined),
    [deliveryDates]
  );
  const shippingEnd = useMemo(
    () => (deliveryDates?.deliveryEndsOn ? new Date(deliveryDates.deliveryEndsOn) : undefined),
    [deliveryDates]
  );

  // For certain types of orders, don't show expected delivery dates,
  // and show customer delivery notes if they exist.
  if (
    [
      FulfillmentTypes.DropShip,
      FulfillmentTypes.Fulfillment,
      FulfillmentTypes.MiraklDropship
    ].includes(fulfilmentType || -1)
  )
    return customerDeliveryNotes ? (
      <Text treatment="body2" color="cement">
        {customerDeliveryNotes}
      </Text>
    ) : null;

  if (!shippingEnd) return null;

  const today = startOfToday();

  if (shippingStart && shippingStart > today) {
    return (
      <div className="PdpDeliveryInfo">
        Shipping est. {`${formatDeliveryDate(shippingStart)} - ${formatDeliveryDate(shippingEnd)}`}
      </div>
    );
  }

  if (shippingEnd > today) {
    return (
      <div className="PdpDeliveryInfo">Shipping est. by {formatDeliveryDate(shippingEnd)}</div>
    );
  }

  return null;
};
